import { ToggleGroup, Options } from '@instructure/ui';
import {
  Badge,
  Tag,
  Tooltip,
  Flex,
  View,
  Text,
} from '@smarterservices/smarter-ui';
import useSessionStore from '../../stores/session';

const InReview = () => {
  const { review } = useSessionStore();

  return (
    <ToggleGroup
      toggleLabel="This is the toggle button label for screenreaders"
      margin="xx-small none none none"
      defaultExpanded={false}
      summary={
        <Flex justifyItems="space-between" margin="none small none none">
          <Flex.Item>Active Check-in</Flex.Item>
          <Flex.Item>
            <Badge
              count={Object.keys(review).length}
              variant="primary"
              standalone
            />
          </Flex.Item>
        </Flex>
      }
    >
      {Object.keys(review).length ? (
        <Options>
          {Object.entries(review).map(([sessionSid, data]) => (
            <Options.Item key={`session_review_${sessionSid}`}>
              <Flex alignItems="center">
                <Flex.Item width="3rem">
                  <Tag size="small" text="21" />
                </Flex.Item>
                <Tooltip
                  color="primary-inverse"
                  renderTip="Jenn Plez (Room Scan)"
                  placement="end"
                >
                  <Flex.Item grow>
                    {data.firstName} {data.lastName}
                  </Flex.Item>
                </Tooltip>
              </Flex>
            </Options.Item>
          ))}
        </Options>
      ) : (
        <View as="div" padding="small" textAlign="center">
          <Text>No sessions being checked in</Text>
        </View>
      )}
    </ToggleGroup>
  );
};

export default InReview;
